import { styled } from '@uhg-abyss/web/tools/styled';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { SelectInput } from '@uhg-abyss/web/ui/SelectInput';

export const StyledSelectInput = styled(SelectInput, {
  '.abyss-select-input-label': {
    color: '$core.color.brand.100',
  },
});

export const DemoProviderSearchContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  fontFamily: '$primary',
  backgroundColor: '$bgHeaderColor',
  paddingTop: '1em',
  paddingBottom: '1.1em',
  marginRight: '24px',
  '@media (max-width: 744px)': {
    marginRight: '16px',
  },
});

export const CollapseIconContainer = styled('div', {
  position: 'relative',
});

export const CollapseIcon = styled(IconSymbol, {
  position: 'absolute',
  right: '24px',
  top: '-42px',
});
